import script from "./WrapperBox.vue?vue&type=script&setup=true&lang=js"
export * from "./WrapperBox.vue?vue&type=script&setup=true&lang=js"

import "./WrapperBox.vue?vue&type=style&index=0&id=954e2de0&lang=scss"

const __exports__ = script;

export default __exports__